import { render } from "./PageDesign.vue?vue&type=template&id=20b29e98&scoped=true"
import script from "./PageDesign.vue?vue&type=script&lang=js"
export * from "./PageDesign.vue?vue&type=script&lang=js"

import "./PageDesign.vue?vue&type=style&index=0&id=20b29e98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b29e98"]])

export default __exports__